import { ServiceTypes } from 'constants/ServiceTypes';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { AutosaveStore } from 'stores/AutosaveStore';
import relativeTime from 'dayjs/plugin/relativeTime';
import { AutosaveInfo, AutosaveTitle, Wrapper } from './styles/AutosaveToggleStyles';

dayjs.extend(relativeTime);

const AutosaveToggle = observer(() => {
  const autosaveStore = useInjection<AutosaveStore>(ServiceTypes.AutosaveStore);
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  let interval: ReturnType<typeof setInterval>;

  useEffect(() => {
    interval = setInterval(() => {
      const timestamp = autosaveStore.load().lastUpdateTimestamp;

      if (timestamp) {
        setLastUpdate(dayjs(timestamp).fromNow());
      } else {
        setLastUpdate(null);
      }
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Wrapper>
      {lastUpdate && lastUpdate.length > 0 && (
        <div>
          <AutosaveTitle>Auto-saved</AutosaveTitle>
          <AutosaveInfo>{`${lastUpdate}`}</AutosaveInfo>
        </div>
      )}
    </Wrapper>
  );
});

export default AutosaveToggle;
